var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMobile = function SvgMobile(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33437 0.733398C4.34615 0.733398 2.73438 2.34517 2.73438 4.3334V11.6667C2.73438 13.655 4.34615 15.2667 6.33437 15.2667H9.66771C11.6559 15.2667 13.2677 13.655 13.2677 11.6667V4.3334C13.2677 2.34517 11.6559 0.733398 9.66771 0.733398H6.33437ZM3.93437 4.3334C3.93437 3.00791 5.00889 1.9334 6.33437 1.9334H9.66771C10.9932 1.9334 12.0677 3.00791 12.0677 4.3334V11.6667C12.0677 12.9922 10.9932 14.0667 9.66771 14.0667H6.33437C5.00889 14.0667 3.93437 12.9922 3.93437 11.6667V4.3334ZM7.33437 12.0674C7.003 12.0674 6.73438 12.336 6.73438 12.6674C6.73438 12.9988 7.003 13.2674 7.33437 13.2674H8.66771C8.99908 13.2674 9.26771 12.9988 9.26771 12.6674C9.26771 12.336 8.99908 12.0674 8.66771 12.0674H7.33437Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMobile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "mobile.63c2bac720f7469dd1a489a8a434dffb.svg";